import { render, staticRenderFns } from "./SelKf.vue?vue&type=template&id=06b4e91e&scoped=true"
import script from "./SelKf.vue?vue&type=script&lang=js"
export * from "./SelKf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b4e91e",
  null
  
)

export default component.exports